/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import {
  VisitStatusEnum,
  VisitTypeEnum,
  VisitOfficeStatusEnum,
  AppointmentInterface,
} from "@malmur-technologies/medicalsystem-shared";
import OfficeVisitForm from "components/forms/NewOfficeVisitForm";

/**
 * Content component for creating a new office visit appointment.
 * Initializes a new office visit with default values including visit type, status,
 * facility information, and displays a form for entering appointment details.
 * @returns {React.ReactElement} The new office visit content component
 */
const NewOfficeVisitDataContent = () => {
  const officeVisit: AppointmentInterface = {
    arrivalDateTime: undefined,
    duration: 20,
    provider: undefined,
    facility: {},
    roomNumber: "101",
    visitType: VisitTypeEnum.NURSE,
    visitStatus: VisitStatusEnum.NO_SHOW,
    visitOfficeStatus: VisitOfficeStatusEnum.WAITING,
    reason: "",
    patient: undefined,
    resource: {},
  };
  return <OfficeVisitForm model={officeVisit} />;
};

export default NewOfficeVisitDataContent;
